import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from './utils/ChakraProvider.tsx'

import { AxiosInterceptor } from '@/api'
import { oidKeycloakConfig } from '@/utils/oidConfig.ts'
import queryClient from '@/utils/queryClient.ts'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'react-oidc-context'

import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import 'leaflet/dist/leaflet.css'
import moment from 'moment'
import 'react-datetime/css/react-datetime.css'
import './i18n'
import './main.css'
// @ts-expect-error Node não encontra o arquivo, mas ele existe
import 'moment/dist/locale/pt-br.js'
import Router from '@/utils/Router.tsx'

moment.locale('pt-br')

globalThis.window.addEventListener('DOMContentLoaded', () => {
  try {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <AuthProvider {...oidKeycloakConfig}>
          <Provider>
            <QueryClientProvider client={queryClient}>
              <AxiosInterceptor>
                <Router />
              </AxiosInterceptor>
            </QueryClientProvider>
          </Provider>
        </AuthProvider>
      </React.StrictMode>
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
})
